export default __webpack_public_path__ + "50534f62fd485434f4f128225cb3eebc.png";